<script lang="ts">
	import { onMount } from 'svelte';
	import { format } from 'svelte-i18n';
	import { Button, Container, Text } from '@Shelly/shelly-design-system';
	import { navigateToCuryThirdPartyLogin } from '../../Lists/list-helpers';
	import TransitionWrapper from '../../Utility/TransitionWrapper.svelte';

	export let error: boolean | string = false,
		err_msg: boolean | string = false,
		bottomMargin: boolean = false;

	const msg = $format('title_cury_app', {
		default: 'Cury app',
	});
	const content = $format('label_cury_description', {
		default:
			'Cury is a member of the Shelly family. You can control your Cury devices with the Shelly Smart Control app and the Cury app with the same account.',
	});

	let loading = false;

	const handle_open_cury = () => {
		navigateToCuryThirdPartyLogin('', true);
	};

	const prepare_page_messages = () => {};

	onMount(() => {
		prepare_page_messages();
	});
</script>

<Container class={bottomMargin ? 'mb-s' : ''}>
	<TransitionWrapper>
		<div class="d-flex flex-direction-column align-items-center">
			<Text element="h1" styleType="h1" class="mb-l text-center">{msg}</Text>

			<Text class="mb-l width-full text-center">{content}</Text>

			<Button
				class="width-md-auto"
				variant={'primary'}
				size="l"
				{loading}
				on:click={handle_open_cury}
				icon="fas fa-external-link"
			>
				{$format('button_open_cury', { default: 'Open Cury' })}
			</Button>
		</div>
	</TransitionWrapper>
</Container>
